import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {Calendar} from "primereact/calendar";
import {FormEvent, Nullable} from "primereact/ts-helpers";
import {useHeaderComponent} from "../hooks/useHeaderComponent";

interface Props {

}

export const YearPicker : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const {yearPickerState, updateYearPicker} = useHeaderComponent();

    const [selectedDate, setSelectedDate] = useState<Nullable<Date>>(new Date());

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleDateChange = (e: FormEvent) => {
        setSelectedDate(e.value);
        updateYearPicker(e.value);
    }

    return <>
        <Calendar view={"year"} dateFormat={"yy"} value={selectedDate} onChange={handleDateChange}/>
    </>
};
